import { render } from "./RankingTable.vue?vue&type=template&id=51338520&scoped=true"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"

import "./RankingTable.vue?vue&type=style&index=0&id=51338520&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51338520"]])

export default __exports__